import {
  formatDateStringRangeWithLocalTimeZone,
  formatDateStringWithLocalTimeZone,
} from "@/lib/dates/formatters";
import { FreightPricingPortalError } from "@/types/error/FreightPricingPortalError";
import { StandardTableConfig, createColumnConfig } from "@stenajs-webui/grid";
import { agreementDocumentsTableCell } from "../components/AgreementDocumentsTableCell";
import { DeleteAgreementDocumentButton } from "../components/DeleteAgreementDocumentButton";
import { DownloadPdfButton } from "../components/DownloadPdfButton";
import { PreviewPdfLink } from "../components/PreviewPdfLink";
import { AgreementDocumentsTableItem } from "../models";
import { AgreementDocumentsTableColumnKeys } from "./RowsAndColumnsConfig";

export const agreementDocumentsTableConfig = (
  error: FreightPricingPortalError | undefined,
  setError: React.Dispatch<
    React.SetStateAction<FreightPricingPortalError | undefined>
  >,
  setDeletedListItems: React.Dispatch<React.SetStateAction<String[]>>
) => {
  const agreementDocumentsTableConfig: StandardTableConfig<
    AgreementDocumentsTableItem,
    AgreementDocumentsTableColumnKeys
  > = {
    enableGridCell: false,
    initialSortOrder: "createdAt",
    initialSortOrderDesc: true,
    keyResolver: (item) => item.id,
    columns: {
      fileName: {
        itemValueResolver: (item) => item.fileName,
        renderCell: ({ label, value, item }) => (
          <PreviewPdfLink item={item} error={error} setError={setError} />
        ),
        columnLabel: "Filename",
      },
      agreementDocumentType: {
        itemValueResolver: (item) => item.agreementDocumentType,
        renderCell: ({ label, value, item }) =>
          agreementDocumentsTableCell(item.agreementDocumentType),
        columnLabel: "Type",
      },
      negotiationYear: {
        itemValueResolver: (item) => item.negotiationYear,
        renderCell: ({ label, value, item }) =>
          agreementDocumentsTableCell(item.negotiationYear),
        columnLabel: "Negotiation year",
      },
      validity: {
        itemValueResolver: (item) => item.agreementValidFromDate,
        renderCell: ({ label, value, item }) =>
          agreementDocumentsTableCell(
            formatDateStringRangeWithLocalTimeZone({
              dateStringFrom: item.agreementValidFromDate,
              dateStringTo: item.agreementValidToDate,
            })
          ),
        minWidth: "165px",
        columnLabel: "Validity",
      },
      createdBy: {
        itemValueResolver: (item) => item.writeHistory.createdBy.id,
        renderCell: ({ label, value, item }) =>
          agreementDocumentsTableCell(item.writeHistory.createdBy.id),
        columnLabel: "Created by",
      },

      createdAt: {
        itemValueResolver: (item) => item.writeHistory.createdAt.isoString,
        renderCell: ({ label, value, item }) =>
          agreementDocumentsTableCell(
            formatDateStringWithLocalTimeZone({
              dateString: item.writeHistory.createdAt.isoString,
              options: {
                dateStyle: "short",
                timeStyle: "short",
              },
            })
          ),
        minWidth: "130px",
        columnLabel: "Created",
      },
      download: {
        itemValueResolver: (item) => item.id,
        renderCell: ({ label, value, item }) => (
          <DownloadPdfButton item={item} error={error} setError={setError} />
        ),
        columnLabel: "",
        width: "40px",
        justifyContentCell: "flex-end",
      },
      deleteDocument: createColumnConfig((item) => item, {
        columnLabel: "",
        renderCell: ({ label, item }) => (
          <DeleteAgreementDocumentButton
            documentId={item.id}
            fileName={item.fileName}
            setDeletedListItems={setDeletedListItems}
          />
        ),
        width: "40px",
        disableGridCell: true,
      }),
    },
    columnOrder: [
      "fileName",
      "agreementDocumentType",
      "negotiationYear",
      "validity",
      "createdBy",
      "createdAt",
      "download",
      "deleteDocument",
    ],
  };
  return agreementDocumentsTableConfig;
};
